// extracted by mini-css-extract-plugin
export default {"sideBar":"script__sideBar___repqt","sideBarHeader":"script__sideBarHeader___TAuoP","tabsMenu":"script__tabsMenu___LE5Za","hidden":"script__hidden___Onfb4"};